import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'ugc-radio-group',
  shadow: false,
})
export class UgcRadioGroup {
  @Prop() options: any;
  @Prop() value: string = '';
  @Prop() radioChange: (value) => void;

  render() {
    return (
      <Host>
        {this.options.map(item => {
          return (
            <ugc-radio
              {...item}
              radioChange={this.radioChange}
              value={item.value}
              checked={item.value === this.value}
              class="ugc-radio"
              data-testid={item.content}
            />
          );
        })}
      </Host>
    );
  }
}
